import { render, staticRenderFns } from "./HelloMessagePc.vue?vue&type=template&id=0ab49568&"
import script from "./HelloMessagePc.vue?vue&type=script&lang=js&"
export * from "./HelloMessagePc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports